import styled from 'styled-components';

const Text = styled.div`
  color: ${(props) => props.color || '#fff'};
  font-size: ${(props) => props.fontSize || 'initial'};
`;

export { Text };
export default Text;
